import React from 'react'
import styles from './detailedEmail.scss'
import stylesOutbox from './outbox.scss'
import Modal from 'react-modal'
import HtmlContent from 'elements/HtmlContent'
import {RenderEmails} from './outboxHelpers'
import cs from 'classnames'
import {Table, Thead, Th, Tr, Td} from 'components/reactable'
import moment from 'moment'
import i18n from 'lib/i18n'
import nesProp from 'nested-property'

const _ = i18n('email')
const _emailSenderTranslates = i18n('emailSender')
const __ = i18n('outbox') /* We need other translations */
const EMAIL_STATUS_FAILED = 'failed'

const customStyles = {
	overlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'rgba(255, 255, 255, 0.75)',
	},
	content: {
		position: 'relative',
		top: 'initial',
		bottom: 'initial',
		left: 'initial',
		right: 'initial',
		maxHeight: '90%',
		overflow: 'auto',
		padding: '0',
    }
}

export default class DetailedEmail extends React.Component {
	static propTypes = {
        email: React.PropTypes.object.isRequired
    }

    constructor(props) {
		super(props)
        this.state = {statusExplainerIsOpen: false}
    }

    /**
     * This function handle the email status modal opening
     * @param {object} item - one email record
     */
    onItemStatusClick(email) {
        const {dispatch} = this.props

        // status check
        if (!email || email.status != EMAIL_STATUS_FAILED) {
            return
        }

        this.setState({statusExplainerIsOpen: email})
    }

    /**
     * This will render the modal content of status explainer in case of error.
     */
    statusExplainerPopup() {
        const {statusExplainerIsOpen} = this.state
		return (
			<div className={stylesOutbox.archiveModalContent}>
				<span className={stylesOutbox.title}>{__('emailStatusMessageModalTitle')}</span>
                <span className={stylesOutbox.message}>
                    <div className={stylesOutbox.emailBodyContainer}>
                        <HtmlContent content={statusExplainerIsOpen.statusMessage} className={stylesOutbox.content}/>
                    </div>
                </span>
				<div className={stylesOutbox.archiveModalButtons}>
					<input
						onClick={() => {
                            this.setState({statusExplainerIsOpen: false})
                        }}
						type="button"
						className={stylesOutbox.greyButton + " enabled"}
						value={__("ok")}
					/>
				</div>
			</div>
		)
	}

    render() {
		const {email, email: {attachments, hardAttachments, externalAttachments}} = this.props
        const {statusExplainerIsOpen} = this.state
        let attachmentsParsed
        try {
            attachmentsParsed = attachments && attachments.filter(a => !!a).map((item)=>JSON.parse(item)) || []
        } catch (error) {
            attachmentsParsed = []
            console.warn("Json parse for attachements error", error);
        }
        // concat the hard attachments also to the list
        attachmentsParsed = attachmentsParsed.concat(hardAttachments || [])
        const recipient = email.recipient || ''
        const recipientTranslationKey = 'recipient'+recipient.charAt(0).toUpperCase() + recipient.slice(1)

		if (!email) {return false}
		return (
            <div className={styles.emailContainer}>
                <h2 className={`${styles.mainTitle}`}>
                    {_('email_title') + (email && ' - "'+email.subject+'"' || '')}
                </h2>
                <div className={styles.emailHeaderContainer}>
                    <div className={cs(styles.row, styles.templateTitle)}>
                        <p className={styles.column}>{_('templateTitle')}: </p>
                        <p className={styles.column}>{email.templateTitle}</p>
                    </div>
                    <div className={cs(styles.row)}>
                        <p className={styles.column}>{__('sentDate')}: </p>
                        <p className={styles.column}>
                            {((email.sentDate != undefined) && moment(email.sentDate).format('DD/MM/YYYY HH:mm:ss')) || "-"}
                        </p>
                    </div>
                    <div className={cs(styles.row, styles.emailStatus)}>
                        <p className={styles.column}>{_('status')}: </p>
                        {email.status != EMAIL_STATUS_FAILED ?
                            <p className={styles.column}>
                                {
                                    (email.status != undefined) &&
                                    (email.wasResent ? __('resent') : __(email.status)) || ""
                                }
                            </p>
                                :
                            <a className={styles.column}
                                onClick={(ev)=>{
                                    ev.stopPropagation()
                                    this.onItemStatusClick(email)
                                }}
                            >
                                {
                                    (email.status != undefined) &&
                                    (email.wasResent ? __('resent') : __(email.status)) || ""
                                }
                            </a>
                        }

                    </div>
                    <div className={cs(styles.row, styles.subject)}>
                        <p className={styles.column}>{_('subject')}: </p>
                        <p className={styles.column}>{email.subject}</p>
                    </div>
                    <div className={cs(styles.row, styles.from)}>
                        <p className={styles.column}>{_('fromUser')}: </p>
                        <p className={styles.column}>{email.userName}
                            {` <`}<a href={`mailto:${email.senderEmail}`}>{email.senderEmail}</a>{`>`}
                        </p>
                    </div>
                    <div className={cs(styles.row, styles.toEmailAddress)}>
                        <p className={styles.column}>{_('recipient')}: </p>
                        <p className={styles.column}>{_emailSenderTranslates(recipientTranslationKey)}</p>
                    </div>
                    <div className={cs(styles.row, styles.toEmailAddress)}>
                        <p className={styles.column}>{_('toEmailAddress')}: </p>
                        <div className={styles.column}>
                            <RenderEmails emails={email.toEmailAddress}/>
                        </div>
                    </div>
                </div>
                <div className={styles.emailBodyContainer}>
                    <HtmlContent content={email.content} className={styles.content}/>
                </div>
                {attachmentsParsed && attachmentsParsed.length > 0 &&
                    <div className={styles.attachmentContainer}>
                        <h2 className={`${styles.title}`}>{_('attachments')} </h2>
                        <Table
                            ref={el => {this.table = el}}
                            id="table"
                            className={styles.attachmentTable}
                            sortable={[
                                {column: 'name', sortFunction: (a,b) => {
                                    let aStr = nesProp.get(a, "props.children")
                                    let bStr = nesProp.get(b, "props.children")
                                    if (!aStr) { aStr = a; }
                                    if (!bStr) { bStr = b; }
                                    return aStr > bStr ? 1: -1
                                }},
                            ]}
                            defaultSort={{
                                column: 'name',
                                direction: 'desc',
                            }}
                            itemsPerPage={10}
                            pageButtonLimit={5}
                        >
                            <Thead>
                                <Th column="name">
                                    <strong>{__("name")}</strong>
                                </Th>
                            </Thead>

                            {attachmentsParsed.map((item, key) =>
                                <Tr i={key} key={key}>
                                    <Td column="name">
                                        <a key={key}
                                            href={`/localdocument?localId=${item.localId}&type=${item.typeDocument || ""}`}
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            {item.aliasFileName || item.name}
                                        </a>
                                    </Td>
                                </Tr>
                            )}
                        </Table>
                    </div>
                }
                {externalAttachments && externalAttachments.length > 0 &&
                    <div className={styles.attachmentContainer}>
                        <h2 className={`${styles.title}`}>{_('externalAttachments')} </h2>
                        <Table
                            ref={el => {this.table = el}}
                            id="tableExternal"
                            className={styles.attachmentTable}
                            sortable={[
                                {column: 'name', sortFunction: (a,b) => {
                                    let aStr = nesProp.get(a, "props.children")
                                    let bStr = nesProp.get(b, "props.children")
                                    if (!aStr) { aStr = a; }
                                    if (!bStr) { bStr = b; }
                                    return aStr > bStr ? 1: -1
                                }},
                            ]}
                            defaultSort={{
                                column: 'name',
                                direction: 'desc',
                            }}
                            itemsPerPage={10}
                            pageButtonLimit={5}
                        >
                            <Thead>
                                <Th column="name">
                                    <strong>{__("name")}</strong>
                                </Th>
                            </Thead>

                            {externalAttachments.map((item, key) =>
                                <Tr i={key} key={key}>
                                    <Td column="name">
                                        <p key={key}>
                                            {item.filename || item.name || ''}
                                        </p>
                                    </Td>
                                </Tr>
                            )}
                        </Table>
                    </div>
                }
                <Modal
                    isOpen={Boolean(statusExplainerIsOpen)}
                    style={customStyles}
                >
                    {this.statusExplainerPopup()}
                </Modal>
            </div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/outbox/detailedEmail.jsx